import { useCallback } from 'react';

import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { PlayerApiError } from '../types/instance';

export const useOnError = (onError?: (err: PlayerApiError) => void) => {
    const handler = useCallback(
        (error: PlayerApiError) => {
            if (error) {
                onError?.(error);
            }
        },
        [onError]
    );

    useInstanceEffect((instance) => instance.onError(handler), [handler]);
};
